export default __webpack_public_path__ + "static/media/lr.45b0874c.svg";